<script setup lang="ts">
import { vOnClickOutside } from '@vueuse/components'

import { useProfileStore } from '@entities/viewer'
import { ItemDropdown, ListDropdown } from '@shared/ui/other'

import { useUserMenu } from '../composables/use-user-menu.hook'
import UserMenuAvatar from './UserMenuAvatar.vue'

defineOptions({
  name: 'UserMenu',
})

const profileStore = useProfileStore()

const {
  refIsShown,
  setShown,
  handleClickOutside,
  setRedirectToProfile,
  setLogout,
} = useUserMenu()
</script>

<template>
  <div
    v-on-click-outside="handleClickOutside"
    class="user-menu"
  >
    <div
      class="user-menu__general"
      :title="profileStore.getUser?.name"
      @click="setShown(!refIsShown)"
    >
      <UserMenuAvatar />
    </div>
    <ListDropdown v-if="refIsShown">
      <ItemDropdown
        text="Profile"
        @click="setRedirectToProfile"
      />
      <ItemDropdown
        text="Logout"
        @click="setLogout"
      />
    </ListDropdown>
  </div>
</template>

<style scoped lang="scss" src="./UserMenu.scss" />
